import { TextCardCombinedProps } from './types';

const usePresenter = (props: TextCardCombinedProps): TextCardCombinedProps => {
  return props;
};

export default usePresenter;
